import { paginationFragment } from './fragments/pagination';

const fragment = `
  id
  name
  email
  phoneNumber
  createdAt
  message
  hasBeenRead
  companyId
  contactId
  emailNotificationLogsCount
  entity {
    __typename
    ... on Community {
      id
      name
    }
    ... on CommunityModel {
      id
      communityName
      modelName
    }
    ... on Project {
      id
      name
    }
    ... on BuildingModel {
      id
      name
      project {
        id
        name
      }
    }
    ... on QuickPossession {
      id
      hashId
      address
      customPrice
      squareFootage
      imageUrl
      deletedAt
      community {
        id
        name
      }
      model {
        id
        name
        beds
        baths
        garages
      }
    }
    ... on Unit {
      id
      hashId
      name
      address
      price
      defaultImageUrl
      deletedAt
      buildingModel {
        id
        name
        bedrooms
        bathrooms
        size
        project {
          id
          name
        }
      }
    }
    ... on Home {
      id
      beds
      baths
      garages
      sizeSqft
      finalPrice
      homeUrl
      createdAt
      deletedByUserAt
      contact {
        id
      }
      singleFamilyHome {
        model {
          id
          name
          imageUrl
          defaultImageUrl
          productType {
            id
            name
          }
        }
        community {
          id
          name
        }
        elevation {
          id
          imageUrl
        }
      }
      multiFamilyHome {
        project {
          id
          name
        }
        unit {
          id
          name
          defaultImageUrl
          buildingModel {
            id
            name
            bedrooms
            bathrooms
            size
          }
        }
      }
    }
  }
`;

export const listMessagesQuery = `
  query ListClientMessages(
    $filter: ClientMessageFilterInput
    $page: Int
    $pageSize: Int
  ) {
    result: listClientMessages(filter: $filter, page: $page, pageSize: $pageSize) {
      items {
        ${fragment}
      }
      pagination {
        ${paginationFragment}
      }
    }
  }
`;

export const countNotReadMessagesQuery = `
  query CountNotReadMessages(
    $companyId: Int
  ) {
    count: countNotReadClientMessages(companyId: $companyId)
  }
`;

export const updateClientMessageQuery = `
  mutation UpdateClientMessage(
    $input: UpdateClientMessageInput!
  ) {
    item: updateClientMessage(input: $input) {
      ${fragment}
    }
  }
`;

export const getClientMessageQuery = `
  query GetClientMessage(
    $id: Int!
  ) {
    item: getClientMessage(id: $id) {
      ${fragment}
    }
  }
`;
